/* eslint-disable */
<template>
  <div id="app">
    <menubar
      @menubar-loading="menubarReady = false"
      @menubar-ready="menubarReady = true"
      style="margin-bottom: -7px"
    />
    <div
      class="app has-tab-menu"
      v-if="tabs[currentRoute] && !tabs[currentRoute].find((t) => t.hidden)"
    >
      <div class="header">
        <menutabs
          :state="{ tabs: tabs[currentRoute] }"
          :tab-selected="tabSelected"
          @tab-select="UpdateSelectedView"
        ></menutabs>
      </div>
    </div>
    <component
      v-if="tabSelected && tabSelected.view"
      :is="tabSelected.view"
      class="component-container"
      v-bind:class="{
        'full-height': (tabs[currentRoute] || [{ hidden: true }]).find(
          (t) => t.hidden
        ),
      }"
    />
    <!--<router-view v-if="menubarReady" style="margin-top:-7px;"/>-->
    <dropdowncontainer :state="tooltipState" />
    <div class="popupmessage-container">
      <popupmessage
        v-for="(popupmessage, imessage) in popupmessages"
        :message="popupmessage"
        :key="imessage + 'i'"
      />
    </div>
    <div>
      <dropdowncontainer
        v-for="(popup, indexP) in genericPopups"
        :state="popup"
        :key="indexP + 'p'"
        @on-close="CheckDropdownContainers"
      />
    </div>
    <div>
      <popupalert
        v-for="(popupalert, ialert) in popupalerts"
        :message="popupalert"
        :key="ialert + 't'"
      />
    </div>
  </div>
</template>

<script>
import dropdowncontainer from "./components/uicomponents/dropdowncontainer";
import popupmessage from "./components/uicomponents/popupmessage.vue";
import popupalert from "./components/uicomponents/popupalert.vue";
import menubar from "./components/MenuBar";
export default {
  name: "App",
  components: {
    dropdowncontainer,
    menubar,
    popupmessage,
    popupalert,
  },
  data() {
    return {
      tooltipState: {
        toggled: false,
        elRelative: null,
      },
      popupmessages: [],
      popupalerts: [],
      genericPopups: [],
      menubarReady: false,
      tabs: {
        filesMain: [
          {
            label: "Promotions",
            view: "promotions",
            selected: true,
            margin: true,
          },
          //{label: 'Korrektur', view: 'corrector', margin: true}
        ],
        company: [
          {
            label: "Benutzerrollen",
            view: "userroles",
            selected: true,
            margin: true,
          },
        ],
        admin: [
          {
            label: "ToDo - Promotions",
            view: "todopromo",
            selected: true,
            margin: true,
          },
          { label: "Sync", view: "sync", selected: true, margin: true },
        ],
        landing: [
          {
            label: "landing",
            view: "landing",
            selected: true,
            margin: true,
            hidden: true,
          },
        ],
      },
      tabSelected: null,
      currentRoute: "",
    };
  },
  created() {
    window.app = this;
    document.body.addEventListener("mousemove", this.WatchMouse);
    document.body.addEventListener(
      "mousemove",
      this.MouseMoveSubscriptionHandler
    );
    document.body.addEventListener("mousedown", this.WatchMouse);
    document.body.addEventListener("mouseup", this.WatchMouse);
    document.addEventListener("touchstart", this.TouchEventToMouseEvent, {
      passive: false,
    });
    document.addEventListener("touchmove", this.TouchEventToMouseEvent, {
      passive: false,
    });
    document.addEventListener("touchend", this.TouchEventToMouseEvent, {
      passive: false,
    });
    document.addEventListener("touchcancel", this.TouchEventToMouseEvent, {
      passive: false,
    });
    window.mouse = { x: 0, y: 0, click: false, element: {} };
    this.UpdateRoute(this.$router.history.current);
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        if (newVal.path === oldVal.path) return; // updated route based on path, since names can be equal
        this.UpdateRoute(newVal);
      },
    },
  },
  methods: {
    UpdateRoute(route) {
      Object.values(this.tabs).forEach((t) =>
        t.forEach((t2) => (t2.selected = false))
      );
      this.currentRoute = route.name;
      if (this.tabs[route.name]) {
        let selectedTab;
        if (route.params.tab) {
          selectedTab = this.tabs[route.name].find(
            (t) => t.view === route.params.tab
          );
        }
        if (!selectedTab) {
          selectedTab = this.tabs[route.name][0];
        }
        this.tabSelected = selectedTab;
        this.tabSelected.selected = true;
      }
      if (window.menubar && window.menubar.$forceUpdate)
        window.menubar.$forceUpdate();
      console.log(
        "CurrentRoute:",
        this.currentRoute,
        "Route:",
        this.$route.name,
        "Path:",
        this.$route.path,
        "TabSelected:",
        this.tabSelected
      );
    },
    UpdateSelectedView(tab) {
      Object.values(this.tabs).forEach((t) =>
        t.forEach((t2) => (t2.selected = false))
      );
      tab.selected = true;
      this.tabSelected = tab;
      this.$router
        .push({ name: this.currentRoute, params: { tab: tab.view } })
        .catch(() => {});
    },
    MouseMoveSubscribe(key, subscribeFunction) {
      this.mouseMoveSubscriptions[key] = subscribeFunction;
    },
    MouseMoveUnsubscribe(key) {
      delete this.mouseMoveSubscriptions[key];
    },
    MouseMoveSubscriptionHandler($event) {
      for (let x in this.mouseMoveSubscriptions) {
        this.mouseMoveSubscriptions[x](window.mouse.element);
      }
    },
    ToggleTooltip(state) {
      let nstate = Object.assign({}, state);
      nstate.tooltip = true;
      if (!nstate.pointerDirection) nstate.pointerDirection = 2;
      if (!nstate.offsety) nstate.offsety = 5;
      this.tooltipState = nstate;
    },
    RepositionTooltip() {
      let view = this;
      let tooltipComponent = this.$children.find(
        (c) => c.state === view.tooltipState
      );
      if (tooltipComponent) tooltipComponent.Reposition();
    },
    CheckDropdownContainers(dropdowncontainer) {
      let view = this;
      if (
        this.$children
          .filter((c) => view.genericPopups.find((g) => c.state === g))
          .every((c) => !c.toggled)
      )
        view.genericPopups = [];
    },
    TouchEventToMouseEvent($event) {
      var touches = $event.changedTouches,
        first = touches[0],
        type = "";
      switch ($event.type) {
        case "touchstart":
          type = "mousedown";
          break;
        case "touchmove": {
          if (window.roster && window.roster.dayMode) $event.preventDefault();
          type = "mousemove";
          break;
        }
        case "touchend":
          type = "mouseup";
          break;
        default:
          return;
      }

      var simulatedEvent = document.createEvent("MouseEvent");
      simulatedEvent.initMouseEvent(
        type,
        true,
        true,
        window,
        1,
        first.screenX,
        first.screenY,
        first.clientX,
        first.clientY,
        false,
        false,
        false,
        false,
        0 /*left*/,
        null
      );

      first.target.dispatchEvent(simulatedEvent);
      //$event.preventDefault();
    },
    WatchMouse($event) {
      if ($event.type === "mousedown" && $event.which === 1)
        window.mouse.click = true;
      if ($event.type === "mouseup" && $event.which === 1)
        window.mouse.click = false;
      if ($event.type === "mousemove") {
        window.mouse.x = $event.clientX;
        window.mouse.y = $event.clientY;
        window.mouse.element = document.elementFromPoint(
          $event.clientX,
          $event.clientY
        );
      }
    },
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.fullwidth {
  max-width: 100% !important;
}
/*
 * General styles
 */
body {
  /*background-repeat: no-repeat;
    background-image: linear-gradient(rgb(255, 255, 255), rgb(122, 144, 6));*/
  /*background-image: url("./assets/connectwork.png")*/
  background-color: whitesmoke;
}

.card-container.card {
  max-width: 100%;
  padding: 40px 40px;
}

.btn {
  font-weight: 700;
  height: 36px;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  cursor: default;
}

/*
 * Card component
 */
.card {
  background-color: #f7f7f7;
  /* just in case there no content*/
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  /* shadows and rounded borders */
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  /*-moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;*/
}

/*
 * Form styles
 */
.profile-name-card {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin: 10px 0 0;
  min-height: 1em;
}

.reauth-email {
  display: block;
  color: #404040;
  line-height: 2;
  margin-bottom: 10px;
  font-size: 14px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.form-signin #inputEmail,
.form-signin #inputPassword {
  direction: ltr;
  height: 44px;
  font-size: 16px;
}

.form-signin input[type="email"],
.form-signin input[type="password"],
.form-signin input[type="text"] .form-signin input[type="number"],
.form-signin button {
  width: 100%;
  display: block;
  margin-bottom: 10px;
  z-index: 1;
  position: relative;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.form-signin .form-control:focus {
  border-color: rgb(104, 145, 162);
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgb(104, 145, 162);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgb(104, 145, 162);
}

.btn.btn-signin {
  /*background-color: #4d90fe; */
  background-color: rgb(104, 145, 162);
  /* background-color: linear-gradient(rgb(104, 145, 162), rgb(12, 97, 33));*/

  font-weight: 700;
  font-size: 14px;
  height: 36px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  border: none;
  -o-transition: all 0.218s;
  -moz-transition: all 0.218s;
  -webkit-transition: all 0.218s;
  transition: all 0.218s;
}

.btn.btn-signin:hover,
.btn.btn-signin:active,
.btn.btn-signin:focus {
  background-color: rgb(122, 144, 6);
}

.forgot-password {
  color: rgb(104, 145, 162);
}

.forgot-password:hover,
.forgot-password:active,
.forgot-password:focus {
  color: rgb(12, 97, 33);
}
.custom-dialog div {
  box-sizing: border-box;
}
.custom-dialog .dialog-flex {
  width: 100%;
  height: 100%;
}
.custom-dialog .dialog-content {
  flex: 1 0 auto;
  width: 100%;
  padding: 15px;
  font-size: 14px;
}
.custom-dialog .dialog-c-title {
  font-weight: 600;
  padding-bottom: 15px;
}
.custom-dialog .dialog-c-text {
}
.custom-dialog .custom-dialog-buttons {
  display: flex;
  flex: 0 1 auto;
  width: 100%;
  border-top: 1px solid #eee;
}
.custom-dialog .custom-dialog-buttons-none {
  width: 100%;
  padding-bottom: 15px;
}
.custom-dialog-button {
  font-size: 12px !important;
  background: transparent;
  padding: 0;
  margin: 0;
  border: 0;
  cursor: pointer;
  box-sizing: border-box;
  line-height: 40px;
  height: 40px;
  color: inherit;
  font: inherit;
  outline: none;
}
.custom-dialog-button:hover {
  background: rgba(0, 0, 0, 0.01);
}
.custom-dialog-button:active {
  background: rgba(0, 0, 0, 0.025);
}
.custom-dialog-button:not(:first-of-type) {
  border-left: 1px solid #eee;
}
.component-container {
  position: absolute;
  top: 90px !important;
  left: 0;
  width: 100%;
  height: calc(100vh - 90px) !important;
  overflow-x: auto;
  overflow-y: auto;
}

.component-container.full-height {
  top: 0px !important;
  left: 0;
  width: 100%;
  height: calc(100vh - 55px) !important;
}

.form-text.text-muted {
  /* This ensures that muted text in forms (descriptions, etc.) is still visible in dark mode */
  color: var(--contrast-4) !important;
}
.custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
  /* This ensures that disabled text in forms is still visible in dark mode */
  color: var(--contrast-6) !important;
}

hr {
  width: 100%;
  border-top: 1px solid var(--contrast-2) !important;
}
</style>

<style>
@import "./assets/styles/colors_dark.css";
@import "./assets/styles/colors_light.css";
@import "./assets/styles/md.css";
@import "./assets/styles/fontawesome.css";
@import "./assets/styles/md_750px.css";
@import "./assets/styles/md_1380px.css";
@import "./assets/styles/dropdown.css";
@import "./assets/styles/bootstrap.css";
@import "./assets/styles/bootstrap-vue.css";
</style>
